'use strict';
var EducationController = /** @class */ (function () {
    /*@ngInject*/
    function EducationController($scope, $window, $state, EducationService, UserService, $cookies, EducationSubNavService, unleashFeatureService, configurationService) {
        var _this = this;
        this.isHeroTabs = true;
        this.config = {};
        this.config.loggedInAs = 'nonLoggedIn';
        this.$state = $state;
        this.$scope = $scope;
        this.config.level = '1';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '1';
        this.config.activateLevel1Tab = '';
        this.unleashFeatureService = unleashFeatureService;
        this.configurationService = configurationService;
        this.registrationServiceUrl = configurationService.getEnvironmentConfiguration().registrationServiceUrl;
        UserService.get().then(function (user) {
            _this.config.loggedInAs = user.data && user.data.response ? user.data.response.accountType : 'nonLoggedIn';
        });
        EducationService.getClinicalResourcesData()
            .then(function (response) {
            //TODO: The below mocked content has to be removed once we have API implemented
            var resp = {
                "response": [
                    {
                        "id": "clinical_updates",
                        "state_id": "clinicalUpdates",
                        "title": "Clinical Articles and Updates",
                        "content": "Read our latest research summaries, clinical articles and Emerson publications, including The Element."
                    },
                    {
                        "id": "education_partners",
                        "state_id": "educationPartners",
                        "title": "Educational Partners",
                        "content": "Explore clinical and business content from our education partners."
                    },
                    {
                        "id": "clinical_practice_tools",
                        "state_id": "clinicalPracticeTools",
                        "title": "Clinical Practice Tools",
                        "content": "Access our most used tools including dosing calculators, measurement & conversion charts, and more."
                    }
                ]
            };
            _this.config.clinicalResources = resp.response;
        });
        EducationService.getPracticeManagementData()
            .then(function (response) {
            //TODO: The below mocked content has to be removed once we have API implemented
            var resp = {
                "response": [{
                        "id": "building_an_expert_dispensary",
                        "state_id": "buildingAnexpertDispensary",
                        "title": "Building an Expert Dispensary",
                        "content": "A 10 part webinar series on clinical and business tips for effectively incorporating high-quality supplements into your practice."
                    },
                    {
                        "id": "optimizing_clinical_operations",
                        "title": "Optimizing Clinical Operations",
                        "content": "Implement systems that will save you time and streamline your practice.  From office management to hiring staff, it's all here.",
                        "state_id": "optimizingClinicalOperations"
                    },
                    {
                        "id": "mastering_sales_and_marketing",
                        "title": "Mastering Sales and Marketing",
                        "content": "Do you feel like you are not connecting with your patients? Cut through the noise and position yourself as the expert in your field.",
                        "state_id": "masteringSalesAndMarketing"
                    },
                    {
                        "id": "leveraging_technology",
                        "title": "Leveraging Technology",
                        "content": "Want more time back?  Learn how to maximize your day by effectively using technology.",
                        "state_id": "leveragingTechnology"
                    },
                    {
                        "id": "enhancing_patient_compliance",
                        "title": "Enhancing Patient Compliance",
                        "content": "The right communication is key when keeping patients compliant and on the road to wellness.",
                        "state_id": "enhancingPatientCompliance"
                    }]
            };
            _this.config.practiceManagement = resp.response;
        });
        this.config.logIn = function () {
            $cookies.put('eeprevurl', $window.location.pathname);
            $window.location = '/auth/ares';
        };
        this.config.signUp = function () {
            $window.location = $scope.singleRegistrationFlag ? this.registrationServiceUrl + 'emerson/register' : '/registration';
        };
    }
    EducationController.prototype.$onInit = function () {
        var _this = this;
        this.unleashFeatureService
            .isEnabledObserveViaName('ares-single-registration')
            .subscribe(function (isEnabled) {
            _this.$scope.singleRegistrationFlag = isEnabled;
        });
    };
    return EducationController;
}());
export default EducationController;
//# sourceMappingURL=education.controller.js.map